import getCompanyFeatures from "v2/infrastructure/common/repositories/getCompanyFeatures";

const findCompanyFeatures = getCompanyFeatures;

export default findCompanyFeatures;
